<template>
    <div>
        <div class="modal-avatar">
            <div class="avatar-left">
                <template v-if="redPlayer">
                    <!-- 只有蓝队 -->
                    <AvatarList :avatarList="redPlayerList"/>
                </template> 
                <template v-else> 
                    <AvatarList :avatarList="bluePlayerList"/>
                </template> 
            </div>
            <div class="avatar-middle">
                <div class="group">{{combatName}}</div>
                <template v-if="redPlayer">
                    <div class="score" >{{redPlayer.totalScore}}  : {{bluePlayer.totalScore}}</div>
                </template>
                <template v-else>
                    <div class="score" >{{bluePlayer.totalScore}}</div>
                </template>
            </div>
            <div class="avatar-right" >  
                <template v-if="redPlayer">
                    <AvatarList :avatarList="bluePlayerList"/>
                </template>
                 <!-- 只有蓝队显示排名 -->
                <template v-else>
                    <div class="ranking">
                         <span v-if="bluePlayer.rank&&bluePlayer.rank>0">第{{bluePlayer.rank&&bluePlayer.rank>0?bluePlayer.rank:''}}名</span>
                        <span v-else v-for="(rank,index) in rankList" :key="index">{{rank.num==bluePlayer.rank?rank.name:''}}</span>
                    </div>
                </template>
            </div>
            
        </div>
        <div class="modal-line"></div>
    </div>
</template>

<script>
import AvatarList from './content/AvatarList.vue'
export default {
  name:'StreetModalAvatarGroup',
  props:['technicalHeaderVo','combatName'],
  components:{AvatarList},
  data () {
    return {
      rankList: [
        {num:null,name:'暂无排名'},
        {num:0,name:'暂无排名'},
        {num:-1,name:'晋级'},
        {num:-2,name:'淘汰'},
        {num:-3,name:'加赛'},
        {num:-4,name:'失格'},
        {num:-5,name:'弃权'},

      ]
    }
  },
  computed: {   
    bluePlayer () {
      return this.technicalHeaderVo.bluePlayer || false
    },
    bluePlayerList () {
      return this.technicalHeaderVo.bluePlayers || []
    },
    redPlayer () {
      return this.technicalHeaderVo.redPlayer || false
    },
    redPlayerList () {
      return this.technicalHeaderVo.redPlayers || []
    }
  },
}
</script>

<style lang="scss" scoped>

.modal-avatar{
    width: 100%;
    height: 140px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding-top:18px ;
    color: #333333;
    text-align: center;
    .avatar-left,
    .avatar-right{
        width: 430px;
        height: 100%;
        display: flex;
        flex-wrap: nowrap;
            .img{
            clip: rect(0,100px);
            width: 80px;
            height: 80px;
            text-align: center;
            border-radius: 10px;
            font-weight: Medium;
            }
            .name{
                line-height: 40px;
                font-size: 14px;
                color: #333333;
                text-align: center;
            }  
    }

    // 不同样式
    .avatar-left{
        justify-content: flex-start;
        .avatar-box{
               margin-right:3px;
            }
    }
    .avatar-right{
        text-align: right;
        justify-content: flex-end;
        .avatar-box{
            margin-left:3px;
            margin-right:0;
        }
        .ranking{
            width: 160px;
            height: 40px;
            line-height: 40px;
            font-size: 18px;
            font-weight: bold;
            border-radius: 20px;
            background-color: #2773D5;
            text-align: center;
            color: #ffffff;
            margin-top: 30px;
        }
     
    }
    .avatar-right-rank{
        text-align: right;
        padding-top:35px ;
    }
    .avatar-middle{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 250px;
            .group{
            color: #888888;
            font-size: 14px;
            }
            .score{
            font-size: 52px;
            font-weight: Bold;
            color: #333333;
            }
        
        }

    }
    .modal-line{
        width: 100%;
        height: 4px;
        background-color: #F6F6F6;
    }

</style>


// WEBPACK FOOTER //
// src/comm/components/modal/taekwondo/TaekwondoModalAvatarGroup.vue